import http from "@/components/services/http-common";

/**
 * Service class for IT Department WorkPlan API operations.
 * Customized to load support/IT departments instead of store branches.
 */
export default class Api {
  // Fetch support/IT departments (departmentTypeCode = K00001) instead of operation branches (K00002)
  getBranches = () => http.get('departments?departmentTypeCode=K00001&authorize=true')

  // Fetch employee rotation details for a specific month
  getEmployeeRotations = (month) => http.get(`employeeRotationDetails/by-month/${month}`)

  // Get list of employees belonging to a specific department code
  getEmployeesByDept = (storeCode) => http.get(`employees/dept/${storeCode}`)

  // Retrieve work plans for a department within a date range
  getWorkPlans = (storeCode, fromDate, toDate, type) => http.get('workplans/it', {
    params: {
      storeCode,
      fromDate,
      toDate,
      type
    }
  })

  // Submit/create new work plans
  createWorkPlan = (payload) => http.post('workplans/it', payload)

  // Retrieve overtime OT plans for a department within a date range
  getOvertimePlans = (storeCode, fromDate, toDate, type) => http.get('workplans/it', {
    params: {
      storeCode,
      fromDate,
      toDate,
      type
    }
  })

  // Submit/create new overtime OT plans
  createOvertimePlan = (payload) => http.post('workplans/it', payload)

  // Delete a specific work plan / OT entry for an employee on a date
  deleteWorkPlan = (employeeCode, workDate, type) => http.delete(`workplans/it/${employeeCode}/${workDate}`, {
    params: {
      type
    }
  })

  // Check-in / check-out enroll test helper
  enroll = (employeeCode, workDate, checkin, checkout, type = 'shift') => http.get('workplans/it/enroll', {
    params: {
      employeeCode,
      workDate,
      checkin,
      checkout,
      type
    }
  })

  // Reset check-in / check-out enroll data
  resetEnroll = (employeeCode, workdate) => http.delete('workplans/it/enroll', {
    params: {
      employeeCode,
      workdate
    }
  })
}
